import moment from 'moment';
import {TOYOTA_RUC} from '../common/constants/dealer';
import {transformDateFormat} from '../common/constants/datesFormat';

function transformDate(date) {
  if (date && moment(date).isValid) {
    return moment(date).format(transformDateFormat);
  }
  return '';
}

function quantityFormat(number = '', initialZeros = 11, endZeros = 11) {
  const numberToSring = String(number);
  const split = numberToSring.split('.');
  const initial = split[0].padStart(initialZeros, 0);
  let end = ''.padEnd(endZeros, 0);
  if (split.length === 2) {
    end = split[1].padEnd(endZeros, 0);
    return `${initial}.${end}`;
  }
  return `${initial}.${end}`;
}

function quantitySixZeros(number = '') {
  const numberToSring = String(number);
  return numberToSring.padStart(6, 0);
}

function createDetail(items) {
  let result = '';
  if (items.length > 0) {
    /* eslint-disable max-len */
    /* eslint-disable-line max-statements */
    /* eslint-disable-next-line max-statements */
    items.forEach(({item, quantity, total, price, chassis, orderType, fr, katashiki, sfx, motor,
      yearFabric, ramv, externalColor, internalColor, createDate, carOrder}) => {
      if (orderType === 'VEH') {
        const itemFormat = katashiki.padEnd(40, ' ');
        const sfxFormat = sfx.padEnd(3, ' ');
        const chasisFormat = chassis.padEnd(30, ' ');
        const motorFormat = motor.padStart(20, ' ');
        const yearFabric2 = String(yearFabric);
        const yearFabricFormat = yearFabric2.padEnd(4, ' ');
        const createDateFormat = createDate.padEnd(8, ' ');
        const ramvFormat = ramv.padEnd(10, ' ');
        const externalColorFormat = externalColor.padEnd(3, ' ');
        const internalColorFormat = internalColor.padEnd(3, ' ');
        const prices = price.padStart(10, ' ');
        /* eslint-disable max-len */
        const line = `${itemFormat}${sfxFormat}${chasisFormat}${motorFormat}${yearFabricFormat}${createDateFormat}${ramvFormat}${externalColorFormat}${internalColorFormat}${prices}${carOrder}\n`;
        result = result + line;
      } else {
        const itemFormat = item.padEnd(15, ' ');
        const validateOrder = orderType ? orderType : 'E';
        const orderTypeFormat = validateOrder.padStart(9, ' ');
        const validateChassis = chassis ? chassis : ''.padStart(17, ' ');
        const frFormat = String(fr && fr !== '' ? fr : ' ').padStart(2, ' ');

        const line = `${itemFormat}${quantitySixZeros(
          quantity
        )}.${quantityFormat(price, 11, 2)}${quantityFormat(
          total,
          10,
          2
        )}.${frFormat}${validateChassis}${orderTypeFormat}\n`;
        result = result + line;
      }
    }
    );
  }
  return result;
}

function createDetailCombos(items) {
  let result = '';
  if (items.length > 0) {
    items.forEach(({codeCombo, total, chassis, fr}) => {
      const itemFormat = codeCombo.padEnd(15, ' ');
      const validateChassis = chassis ? chassis : ''.padStart(21, ' ');
      const frFormat = fr && fr !== '' ? fr : '  ';
      const line = `${itemFormat}${quantitySixZeros(1)}.${quantityFormat(
        total,
        11,
        2
      )}${quantityFormat(total, 10, 2)}.${frFormat}${validateChassis}\n`;
      result = result + line;
    });
  }
  return result;
}


/* eslint-disable-line max-statements */
/* eslint-disable-next-line max-statements */
export const createContent = ({invoice, invoicesItem, invoicesCombos, showCombo}) => {
  const {
    clientRuc,
    date,
    physicalNumber,
    serial,
    sriAuth,
    validityDate,
    subtotal,
    discount,
    tax,
    total,
    clientAgency,
    sriAuthDate,
    taxPercentage,
  } = invoice;

  const {orderType} = invoicesItem.length === 0 ? ' ' : invoicesItem[0];
  if (orderType !== 'VEH') {
    if (
      !sriAuthDate ||
      !sriAuth ||
      !validityDate ||
      !clientRuc ||
      !clientAgency
    ) {
      return null;
    }
    const TRANSPORTATION_COST = 0;
  
    const dealerInfo = `${clientAgency || ''}${TOYOTA_RUC}${transformDate(
      date
    )}${physicalNumber}${serial.replace('-', '')}${transformDate(
      sriAuthDate
    )}${sriAuth}`;
    const quantitiesTotal = `${quantityFormat(subtotal, 10, 2)}${quantityFormat(
      discount || 0,
      9,
      2
    )}${quantityFormat(tax, 9, 2)}${quantityFormat(
      TRANSPORTATION_COST,
      9,
      2
    )}${quantityFormat(total, 10, 2)}`;
    const content = showCombo ?
      createDetailCombos(invoicesCombos) :
      createDetail(invoicesItem);
    return `${dealerInfo}\n${quantitiesTotal}\n${content}`;
  }

  const rucTdeFormat = String(TOYOTA_RUC).padEnd(15, ' ');
  const subtotalFormat = String(subtotal).replace('.', '').padStart(10, '0');
  const discountFormat = String(discount || 0).padStart(10, '0');
  const taxPercentageFormat = String(taxPercentage * 100).padStart(4, '0');
  const taxFormat = String(tax).replace('.', '').padStart(10, '0');
  const totalFormat = String(total).replace('.', '').padStart(10, '0');
  const dealerInfo = `${rucTdeFormat}${transformDate(date)}${serial.replace(
    '-',
    ''
  )}${physicalNumber}${transformDate(sriAuthDate)}${sriAuth}`;
  const quantitiesTotal = `${subtotalFormat}${discountFormat}${taxPercentageFormat}${taxFormat}${totalFormat}`;
  const content = showCombo ?
    createDetailCombos(invoicesCombos) :
    createDetail(invoicesItem);
  return `${dealerInfo}${quantitiesTotal}\n${content}`;
};

export const validateTypeInvoice = (route) => {
  if (route === 'LOG') {
    return 'LOGISTICA';
  }
  if (route === 'CPD') {
    return 'REPUESTOS';
  }

  if (route === 'LBR') {
    return 'LUBRICANTES';
  }

  return 'DISPOSITIVO SATELITAL';
};
